module.exports = __webpack_public_path__ + "img/help.e37e9968.svg";